import { StyledSVG } from '../../Atoms/SVG/styles'
import { styled } from '../../Styles/stitches.config'

export const ShowQuickResponses = styled('div', {
    alignItems: 'center',
    bgc: '$white',
    cursor: 'pointer',
    display: 'grid',
    gap: '$2',
    gridAutoFlow: 'column',
    zIndex: '$dropdown',

    [`& ${StyledSVG}`]: {
        transition: '$default',
    },
})

export const MainResponses = styled('div', {
    display: 'grid',
    transition: '$slow',
    whiteSpace: 'nowrap',

    '&::-webkit-scrollbar': {
        background: 'transparent',
        w: 0,
    },

    '.slick-slider': {
        m: 0,
    },

    '.slick-track': {
        justifyContent: 'flex-start !important',
    },
})

export const QuickResponses = styled('div', {
    alignItems: 'start',
    bgc: '$white',
    display: 'grid',
    gap: '$1',
    gridAutoFlow: 'column',
    overflow: 'hidden',
})

export const SubResponses = styled('div', {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    gap: '$2',
    ml: '$1',
    mt: '$2',
})

export const StyledChatInput = styled('div', {
    bgc: '$white',
    display: 'grid',
    gap: '$2',
    w: '100%',
})
